<template>
<div>
  <transition name="fade-transform"  mode="out-in">
    <router-view @removeFilter="removeFilter" />
  </transition>
</div>
</template>
<script>
export default {
  data () {
    return {
     
    }
  },
  mounted(){
  
  },
  methods: {
    removeFilter() {
      this.$emit('removeFilter')
    }
  },
  components: {}
}
</script>
<style lang="less">
 
</style>



// WEBPACK FOOTER //
// src/views/law/container.vue